module.exports = __webpack_public_path__ + "static/media/QRcode.1a5c5894.jpg";